import { api } from "./api";

export const SPEEDS = [
  { id: "slower", label: "Slower", rate: 0.8, desc: "Extra slow and spacious" },
  { id: "calm", label: "Calm", rate: 0.88, desc: "Gently paced (default)" },
  { id: "normal", label: "Normal", rate: 1.0, desc: "Everyday speaking pace" },
];
export const DEFAULT_READ = { autoPlay: false, speed: "calm" };
const rateOf = (id) => (SPEEDS.find((s) => s.id === id) || SPEEDS[1]).rate;

let audio = null;
let current = null;
let notify = null;
let queue = [];
let playId = 0;
const cache = new Map();

function fetchAudio(key, text, speed) {
  if (!cache.has(key)) {
    const p = api
      .post("/tts/read", { text: text.slice(0, 4000), speed: rateOf(speed) }, { responseType: "blob", timeout: 90000 })
      .then(({ data }) => URL.createObjectURL(data));
    p.catch(() => cache.delete(key));
    cache.set(key, p);
  }
  return cache.get(key);
}

const set = (state) => notify?.(state);

function finish() {
  playId += 1;
  audio?.pause();
  audio = null;
  set("idle");
  current = null;
  notify = null;
}

function next() {
  finish();
  const n = queue.shift();
  if (n) play(n.text, n.onState, n.speed);
}

async function play(text, onState, speed) {
  const id = ++playId;
  current = text;
  notify = onState;
  set("loading");
  try {
    const url = await fetchAudio(`${speed}:${text}`, text, speed);
    if (id !== playId) return;
    const a = new Audio(url);
    audio = a;
    a.onended = () => audio === a && next();
    await a.play();
    if (id !== playId) return a.pause();
    set("playing");
  } catch {
    if (id === playId) {
      set("error");
      current = null;
      notify = null;
      next();
    }
  }
}

function dropQueue(filter = () => true) {
  const gone = queue.filter(filter);
  queue = queue.filter((q) => !filter(q));
  gone.forEach((q) => q.onState("idle"));
}

export function stopReading() {
  dropQueue();
  finish();
}

// Manual Listen: interrupts anything playing.
export function readAloud(text, onState, speed = "calm") {
  stopReading();
  play(text, onState, speed);
}

// Auto-play: waits its turn instead of cutting off a note already being read.
export function queueRead(text, onState, speed = "calm") {
  if (current === text || queue.some((q) => q.text === text)) return;
  if (current) {
    queue.push({ text, onState, speed });
    onState("queued");
  } else play(text, onState, speed);
}

export function cancelRead(text) {
  dropQueue((q) => q.text === text);
  if (current === text) next();
}

export const isReading = (text) => current === text;
